import { useLocation, Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { resetConsent } from "@/lib/cookieConsent";

// @ts-ignore - injected at build time by Vite define
const commitHash: string = typeof __GIT_COMMIT_HASH__ !== "undefined" ? __GIT_COMMIT_HASH__ : "dev";
// @ts-ignore
const commitTimestamp: string = typeof __GIT_COMMIT_TIMESTAMP__ !== "undefined" ? __GIT_COMMIT_TIMESTAMP__ : "";

const footerLinks = [
  { label: "Home", hash: "" },
  { label: "Services", hash: "#services" },
  { label: "Team", hash: "#team" },
  { label: "Insights", hash: "#insights", path: "/insights" },
];

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <footer className="relative py-12">
      {/* Gradient top fade instead of hard border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <div className="absolute top-0 left-0 right-0 h-8 bg-gradient-to-b from-border/10 to-transparent" />

      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center gap-6">
          <a href={isHome ? "#" : "/"} className="group">
            <img
              src="/images/tn-logo.png"
              alt="TechNeed logo"
              className="h-14 w-auto transition-all duration-300 group-hover:drop-shadow-[0_0_8px_hsl(221_83%_46%/0.4)]"
              width={56}
              height={56}
            />
          </a>

          <p className="text-sm text-muted-foreground text-center max-w-md">
            Clarity, momentum, and a partner who understands both your business and technology.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.path ? link.path : isHome ? link.hash || "/" : `/${link.hash}`}
                className="text-primary hover:text-primary/80 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social link */}
          <a
            href="https://www.linkedin.com/company/techneedsolutions"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
            aria-label="TechNeed on LinkedIn"
          >
            <Linkedin className="w-5 h-5" />
          </a>

          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} TechNeed LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <span>•</span>
            <a href="/privacy#your-rights-ccpa" className="hover:text-foreground transition-colors">
              Do Not Sell My Personal Information
            </a>
            <span>•</span>
            <button type="button" onClick={resetConsent} className="hover:text-foreground transition-colors">
              Manage Cookie Preferences
            </button>
          </div>
          <p className="text-[10px] text-muted-foreground font-mono tracking-tight">
            Hash {commitHash}
            {commitTimestamp && (
              <span className="ml-2">
                {new Date(commitTimestamp).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
